// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".index__container__3177W {\n  height: calc(100% - 6px);\n}\n.index__container__3177W.index__hide__196wY {\n  display: none;\n}\n", "",{"version":3,"sources":["webpack://./src/components/PageVisible/index.less"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;AAAE;EACE,aAAA;AAEJ","sourcesContent":[".container {\n  height: calc(100% - 6px);\n  &.hide {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "index__container__3177W",
	"hide": "index__hide__196wY"
};
export default ___CSS_LOADER_EXPORT___;
